import React from 'react';
import {FieldViewProps} from "../../../render/view";
import UserIcon from "../../../../gd-ui/icon/user/user";

export default function FieldUser_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    const user = gd.session.users.get(value)

    if (!user) return false

    // ?????? who did it ? why classes ???? wooooo......
    const style = {
        minHeight: 24,
        overflow: 'hidden', //required for txt-truncate to work correctly
    }

    const companyUser = gd.session.companyUsers.getByUserId(user.id) || {isActivated: false}

    const nameClasses = Classes("txt-truncate", {
        "ui5-txt-default"       : companyUser.isActivated,
        "ui5-txt-not-important" : !companyUser.isActivated
    })

    return (
        <div className="flex-row-left-center" style={style}>
            <UserIcon className="m-r-8" userId={user.id} size="22"/>
            <div className={nameClasses}>
                {user.name}
            </div>
        </div>
    )
}
